import React, { useEffect } from "react";
import { TitleWithSearch } from "../../components/titleWithSearch";
import { TrocaTelas } from "../../components/trocaTelas";
import "../../assets/styles/tableEap.css";
import "../../assets/styles/input.css";
import "../../assets/styles/modalComponent.css";
import { animationModal } from "../../utils";
import backHeader from "../../assets/img/Back - Header.svg";
import { Link, useParams } from "react-router-dom";
import { ModalInfos } from "../../components/modal";
import { ModalSure } from "../../components/modalExcluir";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import filtro from "../../assets/img/Icon material-filter-list.svg";
import Switch from "@mui/material/Switch";
import { styled } from '@mui/material/styles';
import plusIcon from "../../assets/img/Icon-ionic-ios-add.svg"
import axiosInstance from "../../auth/axiosInstance";

const CPU = () => {
  const [initialData, setInitialData] = React.useState([]);
  const [checked, setChecked] = React.useState(true);
  const [label, setlabel] = React.useState("Projeto atualizado com sucesso!");
  const [values, setValues] = React.useState();
  const [labelError, setlabelError] = React.useState({
    label: "Erro ao adicionar Projeto!",
    sugestao: "Favor revisar nome do Projeto ou Arquivo",
  });
  const [showModal, setShowModal] = React.useState(false);
  const [showModal2, setShowModal2] = React.useState(false);
  const [showModal3, setShowModal3] = React.useState(false);
  const [cpuId, setCpuId] = React.useState(0);
  const [insumoId, setInsumoId] = React.useState(0);
  const [selected, setSelected] = React.useState(null);
  const [cpuSelecionada, setCpuSelecionada] = React.useState({});
  const [searchValue, setSearchValue] = React.useState("");
  const [filter, setFilter] = React.useState([]);
  const [filtroData, setFiltroData] = React.useState([]);
  const [selectFilter, setSelectFilter] = React.useState(0);
  const [inverter, setInverter] = React.useState(false);
  const [codComp, setCodComp] = React.useState("");
  const [indice, setIndice] = React.useState();
  const [codIns, setCodIns] = React.useState("");
  const [cpuAndInsumo, setCpuAndInsumo] = React.useState([]);
  const [cpuCodigos, setCpuCodigos] = React.useState([]);
  const [todosTipos, setTodosTipos] = React.useState([]);


  React.useEffect(() => {
    getInitial()
    setSelectFilter(localStorage.getItem("cpuId") || "");

  }, [])

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#00838D',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));

  const onChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const [page, setPage] = React.useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const paginate = (array, page_size, page_number) => {
    if (inverter === false) {
      return array.slice((page_number - 1) * page_size, page_number * page_size);
    } else {
      return array
        .slice((page_number - 1) * page_size, page_number * page_size)
        .reverse();
    }

  };

  const searchHandler = ({ target }) => {
    localStorage.removeItem("cpuId");
    setSearchValue(target.value);
    setSelectFilter(target.value);
    setPage(1);
  };

  const filteredData = searchValue || selectFilter
    ? !checked
      ? initialData.filter((value) =>
        Object.values(value)
          .join(" ")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      )
      : initialData.filter((value) =>
        value.cpuId == selectFilter ?
          Object.values(value)
            .join(" ")
            .toLowerCase()
            .includes(searchValue.toLowerCase())
          :
          null
      )
    : initialData;
  let custoTotal = 0
  filteredData.forEach(value => {
    custoTotal = custoTotal += value.custo
  })

  const changeFilter = ({ target }) => {
    setChecked(target.checked);
  };

  const paginatedData = paginate(filteredData, 30, page);
  const totalPages = Math.ceil(filteredData.length / 30);

  const param = useParams();

  async function getInitial() {
    await axiosInstance(`filter/Cpu_bd/${param.cpu}`).then((res) => {
      // console.log(res.data)
      setInitialData(res.data);
      setFiltroData(res.data);
      setFilter(res.data);
      setCpuCodigos(res.data)
    });

    await axiosInstance(`insumos_cpu/${param.cpu}`)
      .then(res => {
        setCpuAndInsumo(res.data)
      })
  }

  React.useEffect(() => {
    getInitial();
  }, []);

  const getUpdates = async () => {
    // sessionStorage.clear();
    axiosInstance(`filter/Cpu_bd/${param.cpu}`).then((res) => {
      setInitialData(res.data);
    });
  };

  async function putGeral(sheet, id, eapid) {
    const body = Object.assign(values, { insumoId: cpuSelecionada.insumoId })
    await axiosInstance
      .put(`filter/${sheet}/${id}/${eapid}`, body)
      .then((res) => {
        if (res.status === 200) {
          setlabel("Projeto atualizado com sucesso!");
          setShowModal(true);
          animationModal("modal-new-action", "background-new-plan");
          setValues(undefined);
          getUpdates();
          setTimeout(() => {
            getInitial();
          }, 5);
        }
      });
  }

  async function deleteCpu() {
    try {
      await axiosInstance
        .delete(`filter/Cpu_bd/${cpuId}-${insumoId}/${param.cpu}`)
        .then((res) => {
          if (res.status === 200) {
            setlabel("CPU removida com sucesso!");
            setShowModal(true);
            setValues(undefined);
            getUpdates();
            setShowModal3(false);
            setTimeout(() => {
              getInitial();
            }, 100);
          }
        });
    } catch (error) {
      setlabelError({
        label: "Erro ao deletar CPU!",
        sugestao: "Favor tente novamente",
      });
      setShowModal2(true);
      setShowModal3(false);
    }
  }

  async function postInsumo() {
    try {
      const codigo = param.cpu;
      await axiosInstance.post(`filter/Cpu_bd`, {
        "eapId": codigo,
        "cpuId": codComp,
        "insumoId": codIns,
        "indice": indice
      })
        .then(res => {
          if (res.status === 201) {
            setlabel('Insumo adicionado com sucesso!')
            setShowModal(true)
            setValues({})
            animationModal('modal-new-action-add', 'background-new-plan-add')
            getUpdates()
            setShowModal3(false)
            setTimeout(() => {
              getInitial()
            }, 100);
          }
        })

      setCodComp("");
      setCodIns("");
      setIndice();
    } catch (error) {
      setlabelError({ label: 'Erro ao adicionar Insumo!', sugestao: 'Favor tente novamente' })
      setShowModal2(true)
      setShowModal3(false)
    }
  }

  function disableInputs() {
    setCodComp("");
    setCodIns("");
    setIndice();

    animationModal('modal-new-action-add', 'background-new-plan-add')
  }

  const searchHandlerCodigoInsumo = ({ target }) => {

    setTodosTipos([]);

    if (target.id === "input-codigo") {
      setShowDivCpu(false);
      if (target.value) {
        setShowDivInsumo(true);
        const newData = cpuAndInsumo.insumos.filter((value) => {
          return Object.values(value)
            .join("")
            .toLowerCase()
            .includes(target.value.toLowerCase());
        });
        setTodosTipos(newData);
      } else {
        setShowDivInsumo(false);
        setTodosTipos([]);
      }
    } else if (target.id === "input-cpu") {
      setShowDivInsumo(true)
    } else {
      setShowDivCpu(false);
      setShowDivInsumo(false);
      if (target.value) {
        setShowDivCpu(true);
        const newData = cpuAndInsumo.cpu.filter((value) => {
          return Object.values(value)
            .join("")
            .toLowerCase()
            .includes(target.value.toLowerCase());
        });
        setTodosTipos(newData);
      } else {
        setShowDivCpu(false);
        setTodosTipos([]);
      }
    }
  };

  const searchHandlerCodigoCpu = ({ target }) => {

    setTodosTipos([]);

    if (target.id === "input-cpu") {
      setShowDivInsumo(false);
      if (target.value) {
        setShowDivCpu(true);
        const newData = cpuAndInsumo.cpu.filter((value) => {
          return Object.values(value)
            .join("")
            .toLowerCase()
            .includes(target.value.toLowerCase());
        });
        setTodosTipos(newData);
      } else {
        setShowDivCpu(false);
        setTodosTipos([]);
      }
    } else if (target.id === "input-codigo") {
      setShowDivCpu(false);
      if (target.value) {
        setShowDivInsumo(true);
        const newData = cpuAndInsumo.insumo.filter((value) => {
          return Object.values(value)
            .join("")
            .toLowerCase()
            .includes(target.value.toLowerCase());
        });
        setTodosTipos(newData);
      } else {
        setShowDivInsumo(false);
        setTodosTipos([]);
      }
    }
  }

  function getSelectedTipoSubtipo(tipo) {
    let tipoSelected = document.getElementById("input-codigo");
    tipoSelected.value = tipo;
    setTodosTipos(cpuAndInsumo.insumo);
    setCodIns(tipoSelected.value.match(/\d+/)[0]);
    setTodosTipos([]);
  };

  function getSelectedTipoCpu(tipo) {
    let tipoSelected = document.getElementById("input-cpu");
    tipoSelected.value = tipo
    setTodosTipos(cpuAndInsumo.cpu);
    setCodComp(tipoSelected.value.match(/\d+/)[0])
    setTodosTipos([])
  };

  const [showDivInsumo, setShowDivInsumo] = React.useState(true);
  const [showDivCpu, setShowDivCpu] = React.useState(true);

  return (
    <section className="body-table-eap">
      <div className="header-cpu">
        <TitleWithSearch
          title="CPU"
          label="Procurar CPU"
          chevron={true}
          onChange={searchHandler}
          route={`/eap/${param.id}`}
          placeholder={
            checked === false
              ? "Pesquise por Cód. Comp. Cód. INS. Índice e Custo"
              : selectFilter ? selectFilter : "Pesquise por Código Comp."
          }
          botao={true}
          onClick={() => animationModal('modal-new-action-add', 'background-new-plan-add')}
          iconButton={plusIcon}
          labelButton='Novo'
        />

      </div>
      <div className="toggle">
        <Stack direction="row" spacing={1} alignItems="center">
          <h3 className="title-toggle">Pesquisar apenas por Código Comp</h3>
          <AntSwitch
            checked={checked}
            onChange={changeFilter}
            inputProps={{ "aria-label": "controlled" }}
          />
        </Stack>
      </div>

      <TrocaTelas cpu route={`insumo`} />
      {/* { */}
      {/*   console.log(window.innerWidth) */}
      {/* } */}
      <div
        style={window.innerWidth > 1280 ? { height: "55%", paddingBottom: 10 } : { height: "52%", paddingBottom: 10 }}
        className="table-wrapper"
      >
        <table
          style={selected !== null ? { width: "85% !important" } : { width: "95%" }}
          className="table-eap table-cpu"
        >
          <thead>
            <tr>
              <th>
                Código Comp.{" "}
                {inverter === false ? (
                  <img
                    src={filtro}
                    alt="Icone"
                    onClick={() => setInverter(true)}
                  />
                ) : (
                  <img
                    src={filtro}
                    alt="Icone"
                    onClick={() => setInverter(false)}
                    style={{ transform: "rotate(180deg)" }}
                  />
                )}{" "}
              </th>

              <th>Código INS.</th>
              <th className="text-center">Índice</th>
              <th className="text-center">Custo</th>
            </tr>
          </thead>
          <tbody className="crescente">
            {paginatedData.map((value) => {
              return (
                <tr
                  onClick={
                    selected !== null && value === selected
                      ? () => setSelected(null)
                      : () => setSelected(value)
                  }
                  className="tr-body-eap"
                >
                  <td style={{ paddingRight: 30 }}>
                    {value.cpuId} - {value.descricaoCpu}
                  </td>
                  <td>
                    {value.insumoId} - {value.descricaoInsumo} - {value.unidadeInsumo}
                  </td>
                  <td className="text-center">{value.indice.toFixed(4)}</td>
                  <td className="text-center">{value.custo.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  <div
                    style={
                      selected === value
                        ? { display: "flex" }
                        : { display: "none" }
                    }
                    className="options-cpu"
                  >
                    <button
                      onClick={() => {
                        setShowModal3(true);
                        setCpuId(value.cpuId);
                        setInsumoId(value.insumoId);
                      }}
                    >
                      Excluir
                    </button>
                    <button
                      onClick={() => {
                        animationModal(
                          "modal-new-action",
                          "background-new-plan"
                        );
                        setCpuSelecionada(value);
                      }}
                    >
                      Editar
                    </button>
                  </div>
                </tr>
              );
            })}

          </tbody>
        </table>


        <div className="page-component">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChange}
            />
          </Stack>
        </div>
      </div>
      <div className="custo-total-component" style={{ display: 'flex' }}>
        <h1 className="w700 montserrat" style={{ marginRight: 8, fontSize: '1vw' }}>Custo Total:</h1>
        <h2 className="montserrat w500" style={{ fontSize: ' 1vw' }}>{custoTotal.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h2>
      </div>

      <div id="background-new-plan" className="background-new-plan">
        <section id="modal-new-action" className="modal-new-action">
          <div
            onClick={() =>
              animationModal("modal-new-action", "background-new-plan")
            }
            className="fechar-button-style"
          >
            <img src={backHeader} alt="back" />
            <img src={backHeader} alt="back" />
            <h2 className="montserrat ">Fechar</h2>
          </div>
          <h1 className="montserrat azul w600">Alterar CPU</h1>
          <div className="content-inputs">
            <div className="input-component2">
              <div>
                <h3 className="montserrat ">Insumo</h3>
              </div>
              <div className="select-insumo">
                <h3 className="montserrat ">
                  {cpuSelecionada.insumoId} - {cpuSelecionada.descricaoInsumo}
                </h3>
              </div>
            </div>
            <div className="input-component2">
              <div>
                <h3 className="montserrat ">Composição</h3>
              </div>
              <div className="select-insumo">
                <h3 className="montserrat ">
                  {cpuSelecionada.cpuId} - {cpuSelecionada.descricaoCpu}
                </h3>
              </div>
            </div>

            <div className="input-component">
              <div>
                <h3 className="montserrat ">Índice</h3>
              </div>
              <input
                name="indice"
                onChange={onChange}
                placeholder={
                  cpuSelecionada.indice !== null
                    ? cpuSelecionada.indice?.toFixed(4)
                    : "Digite aqui"
                }
                type="number"
              />
              <h4 className="montserrat">EXAMPLE: 35</h4>
            </div>
          </div>

          <div className="button-okay-modal">
            <button className="montserrat w600"
              onClick={() =>
                animationModal("modal-new-action", "background-new-plan")
              }
            >Cancelar</button>
            <button
              className="montserrat w600"
              disabled={values?.indice !== "" ? false : true}
              style={values?.indice !== "" ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }}
              onClick={() =>
                putGeral("Cpu_bd", cpuSelecionada.cpuId, param.cpu)
              }
            >
              Alterar
            </button>
          </div>
        </section>
      </div>

      <div id="background-new-plan2" className="background-new-plan2">
        <section id="modal-new-action2" className="modal-new-action2">
          <div
            onClick={() =>
              animationModal("modal-new-action2", "background-new-plan2")
            }
            className="fechar-button-style"
          >
            <img src={backHeader} alt="back" />
            <img src={backHeader} alt="back" />
            <h2 className="montserrat ">Fechar</h2>
          </div>
          <h1 className="montserrat azul w600">Alterar</h1>
          <div className="content-inputs">
            <div className="input-component2">
              <div>
                <h3 className="montserrat ">Insumo</h3>
              </div>
              <div className="select-insumo">
                <select
                  name="insumoselect"
                  onChange={changeFilter}
                // onChange={e => setSelectFilter(e.target.value)}
                >
                  {/* <option ></option> */}

                  {filter.map((value, i) => {
                    return (
                      <option value={value.insumoId} onChange={changeFilter}>
                        {value.insumoId} - {value.descricaoInsumo}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="input-component2">
              <div>
                <h3 className="montserrat ">Composição</h3>
              </div>
              <div className="select-insumo">
                <select name="insumoselect">
                  {/* <option ></option> */}
                  {/* {filtrado.map((value, i) => {
                    return (
                      <option value={value}>
                        {value.cpuId} - {value.descricaoCpu}
                      </option>
                    );
                  })} */}
                </select>
              </div>
            </div>
            {/* input component */}
            <div className="input-component">
              <div>
                <h3 className="montserrat ">Índice</h3>
              </div>
              <select name="insumoselect" onChange={changeFilter}>
                {/* <option ></option> */}
                {paginatedData.map((value, i) => {
                  return <option value={value.indice}>{value.indice}</option>;
                })}
              </select>
            </div>
          </div>
        </section>
      </div>

      <div id="background-new-plan-add" className="background-new-plan">
        <section id="modal-new-action-add" className="modal-new-action">
          <div onClick={() => animationModal('modal-new-action-add', 'background-new-plan-add')} className="fechar-button-style">
            <img src={backHeader} alt='back' />
            <img src={backHeader} alt='back' />
            <h2 className="montserrat ">Fechar</h2>
          </div>
          <h1 className="montserrat azul w600">Adicionar um Novo Insumo</h1>
          <div>
            <div className="content-inputs">
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Código Comp.</h3>
                  <h5 className='w600'>*</h5>
                </div>
                <input onChange={searchHandlerCodigoCpu} id="input-cpu" type="text" placeholder="Write here" />
                <div style={showDivCpu && todosTipos.length > 0 ? { display: 'flex' } : { display: 'none' }} className="container-checkbox-tipo-subtipo">
                  {
                    todosTipos.map((tipo, i) => {
                      return (
                        <form className="checkbox-tipo-subtipo">
                          <label id="tipo-selected" onClick={() => getSelectedTipoCpu(tipo.id)} style={{ cursor: "pointer", width: "100%" }}>{tipo.id}</label>
                        </form>
                      )
                    })
                  }
                </div>
                <h4 className="montserrat">EXAMPLE: 1 - GERENCIAMENTO ELETROMECÂNICO</h4>
              </div>
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Código INS.</h3>
                  <h5 className='w600'>*</h5>
                </div>
                <input onChange={searchHandlerCodigoInsumo} id="input-codigo" type="text" placeholder="Write here" />
                <div style={showDivInsumo && todosTipos.length > 0 ? { display: 'flex' } : { display: 'none' }} className="container-checkbox-tipo-subtipo">

                  {todosTipos.map((tipo, i) => {
                    return (
                      <form className="checkbox-tipo-subtipo">
                        <label id="tipo-selected" onClick={() => getSelectedTipoSubtipo(tipo.codigo)} style={{ cursor: "pointer", width: "100%" }}>{tipo.codigo}</label>
                      </form>
                    )
                  })
                  }
                </div>
                <h4 className="montserrat">EXAMPLE: 400001 - Gerente de instalações</h4>
              </div>
              <div className="input-component">
                <div>
                  <h3 className="montserrat">Índice</h3>
                  <h5 className='w600'>*</h5>
                </div>
                <input name="indice" value={indice} onChange={(event) => setIndice(event.target.value)} placeholder={cpuSelecionada.indice !== null ? cpuSelecionada.indice : 'Digite aqui'} type='number' />
                <h4 className="montserrat">EXAMPLE: 3,0000</h4>
              </div>
            </div>
          </div>
          <div className="button-okay-modal">
            <button className="montserrat w600" onClick={() => disableInputs()} >Cancelar</button>
            <button className="montserrat w600"
              onClick={() => postInsumo()}
              disabled={codComp === "" || codIns === "" || indice < 0}
              style={codComp !== "" && codIns !== "" && indice >= 0 ? {} : { backgroundColor: '#ccc', cursor: 'not-allowed' }}>Adicionar</button>
          </div>
        </section>
      </div>

      <ModalInfos
        checked={showModal}
        onClick={() => setShowModal(false)}
        label={label}
      />

      <ModalSure
        checked={showModal3}
        error
        label="Você realmente deseja exluir esse Projeto?"
        onClick={() => setShowModal3(false)}
        delete={() => deleteCpu()}
      />

      {/* <ModalFilter
        checked={showModal4}
        error
        label='Você realmente deseja exluir esse Projeto?'
        onClick={() => setShowModal4(false)}
        delete={() => deleteCpu()}
      /> */}
    </section>
  );
};

export default CPU;
